import { useRef } from 'react'
// Material
import { Divider, ListItemButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { TextParser } from '@weblite/web-textparser'
import { isPhoneOrTablet } from '$func/environmentInfo'
import { EMOJI_SPRITE_SHEET } from '$helper/constants/emoji'
import { identifierRenderer } from '$comp/_app/components/chat/components/body/components/messageList/messages/message-bodies/text/identifier-renderer'
import { linkRenderer } from '$comp/_app/components/chat/components/body/components/messageList/messages/message-bodies/text/link-renderer'

const StyledListItemButton = styled(ListItemButton)`
  width: 100%;
  min-height: 66px;
  flex-direction: column;
  margin: 0;
  padding: 8px 15px;
  background-color: transparent;

  outline: none;
  justify-content: flex-start;
  align-items: start;
  text-align: inherit;
`

const StyledDivider = styled(Divider)`
  margin-right: 15px;
  &:last-child {
    display: none;
  }
`

const parsers = [
  { name: 'emoji', args: { spritesheeturl: EMOJI_SPRITE_SHEET } },
  'code',
  { name: 'identifier', fn: identifierRenderer },
  { name: 'link', fn: linkRenderer },
]

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  flexWrap: 'wrap',
  /* @noflip */
  alignItems: 'flex-end',
  boxSizing: 'border-box',
  /* @noflip */
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  wordBreak: 'break-word',
  whiteSpace: 'pre-wrap',
  textAlign: 'initial',
  ...theme.typography.body2,
  '--emoji-size': '18px',
}))

interface Props {
  value: string
  label: string
  placeholder?: string
  onClick: () => unknown
}

// TODO: [refactor] rename props to more meaningful names
// FIXME: maybe list item can be a better option for lists
// FIXME: dir="auto" for now in description but it can be forced to some based on body tag
export function ProfileInfoParser({
  value,
  label,
  placeholder,
  onClick,
}: Props) {
  const containerRef = useRef(null)
  return (
    <>
      <StyledListItemButton
        onClick={(e: any) => {
          onClick()
          e.stopPropagation()
        }}
      >
        <Typography
          gutterBottom
          variant="caption1"
          component="div"
          color="secondary.main"
          sx={{ marginBottom: '5px', textAlign: 'right' }}
        >
          {label}
        </Typography>

        <Container
          ref={containerRef}
          style={{
            userSelect: !isPhoneOrTablet ? 'text' : 'inherit',
          }}
          sx={{ color: value ? 'neutral1000' : 'semiLightGray' }}
        >
          <div dir="auto" style={{ unicodeBidi: 'plaintext', width: '100%' }}>
            <TextParser text={value || placeholder} parsers={parsers} />
          </div>
        </Container>
      </StyledListItemButton>
      <StyledDivider />
    </>
  )
}

ProfileInfoParser.defaultProps = {
  placeholder: '',
}
